import React, { useEffect, useState } from "react";
import "./App.css";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

function App() {
  const [health, setHealth] = useState({ state: "checking", mongo: "—" });

  useEffect(() => {
    let cancelled = false;
    async function ping() {
      try {
        const res = await fetch(`${BACKEND}/api/health`);
        const data = await res.json();
        if (cancelled) return;
        setHealth({
          state: data.status === "ok" ? "ok" : "degraded",
          mongo: data.mongodb || "unknown",
          environment: data.environment,
        });
      } catch (err) {
        if (cancelled) return;
        setHealth({ state: "error", mongo: "unreachable" });
      }
    }
    ping();
    return () => {
      cancelled = true;
    };
  }, []);

  const indicatorClass =
    health.state === "ok"
      ? "indicator indicator--ok"
      : health.state === "checking"
      ? "indicator indicator--idle"
      : "indicator indicator--down";

  return (
    <main className="page" data-testid="landing-page">
      <div className="rule rule--top" aria-hidden="true" />

      <header className="masthead" data-testid="masthead">
        <span className="eyebrow" data-testid="eyebrow">
          Phase 1.2 · Soul Card Service
        </span>
        <span className="ornament" aria-hidden="true">
          ⚘
        </span>
      </header>

      <section className="hero">
        <h1 className="brand" data-testid="brand-name">
          247<span className="brand__stem">concierge</span>
          <sup className="brand__mark">®</sup>
        </h1>

        <p className="tagline" data-testid="tagline">
          Mira listens. Concierge<sup>®</sup> delivers.
        </p>

        <p className="lede" data-testid="lede">
          The Mother of Mira — the unified intelligence engine.
          <br />
          Mira interprets, remembers, judges, orchestrates.
          <br />
          Concierge<sup>®</sup> executes.
        </p>
      </section>

      <section className="status" data-testid="status-card">
        <div className="status__row">
          <span className="status__label">api</span>
          <span className={indicatorClass} data-testid="api-indicator">
            <span className="indicator__dot" aria-hidden="true" />
            <span className="indicator__text" data-testid="api-status-text">
              {health.state === "checking"
                ? "listening"
                : health.state === "ok"
                ? "ok"
                : health.state === "degraded"
                ? "degraded"
                : "unreachable"}
            </span>
          </span>
        </div>
        <div className="status__row">
          <span className="status__label">mongodb</span>
          <span className="status__value" data-testid="mongo-status-text">
            {health.mongo}
          </span>
        </div>
        <div className="status__row">
          <span className="status__label">environment</span>
          <span className="status__value" data-testid="env-status-text">
            {health.environment || "—"}
          </span>
        </div>
      </section>

      <footer className="colophon" data-testid="colophon">
        <p className="colophon__line">
          Same hands since 1998. New loom, on a road we own.
        </p>
        <p className="colophon__meta">
          <span>Bengaluru</span>
          <span className="dot" aria-hidden="true">
            ·
          </span>
          <span>247concierge.ai</span>
          <span className="dot" aria-hidden="true">
            ·
          </span>
          <span>v0.1.0</span>
        </p>
      </footer>

      <div className="rule rule--bottom" aria-hidden="true" />
    </main>
  );
}

export default App;
